module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAuElEQVQ4T8XTYQ3CMBCG4e91gIThAAlIwAHgAAs4QAIOBgrACg7m4EiTLmkI7bWsCfu79dl9d1fU+aGzp/+DZjZImoDpW7qmCs1sI+kh6QxcFoEJdgcOud5XVWhmq1jZC9iVBumCCRa+3eZ6N/+kCLZiAc2Cv2AeGKa4l7T2YqY9LVUYVuQpaQSOtTfK62EzWjPlJtQFQ9S41FXxq8AWtBr8QK/AadFdng/H+ANw6wJ669MU2cPC+zfrzkoVoaADRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/back.png
// module id = 6CPS
// module chunks = 1